import React, { useState } from 'react';
import './StreamStatsPanel.css';

const StreamStatsPanel = ({ stats }) => {
  const [selected, setSelected] = useState('in');

  if (!stats) return null;

  return (
    <div className="stream-stats-panel">
        <div className="stream-stats-header" style={{  color:'white', alignContent:'center',textAlign:'center', paddingTop:'1vh', paddingBottom:'1vh'}}>     
              <h2>Stream Stats</h2>
        </div>
     
    <div className="stats-button-group">
   
      <button
        className={`stats-button ${selected === 'area' ? 'active' : ''}`}
        onClick={() => setSelected('area')}
      >
       Area: {stats.area}
      </button>
      <button
        className={`stats-button ${selected === 'location' ? 'active' : ''}`}
        onClick={() => setSelected('location')}
      >
       Location: {stats.location}
      </button>
      <button
        className={`stats-button ${selected === 'in' ? 'active' : ''}`}
        onClick={() => setSelected('in')}
      >
       In: {stats.vehicles_in}
      </button>
      <button
        className={`stats-button ${selected === 'out' ? 'active' : ''}`}
        onClick={() => setSelected('out')}
      >
        Out: {stats.vehicles_out}
      </button>
      <button
        className={`stats-button ${selected === 'total' ? 'active' : ''}`}
        onClick={() => setSelected('total')}
      >
        Total: {stats.total_vehicles}
      </button>
    </div>
    </div>
  );
};

export default StreamStatsPanel;
